module.exports = __webpack_public_path__ + "media/images/house-a6764a236b12a06b67c0f22144e1099e.jpg";